var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profilePhoto)?_c('img',{staticClass:"social-marketing-studio-image",attrs:{"src":_vm.profilePhoto}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }